export enum DrawTypeEnum {
  setup = "setup",
  search = "search",
  shareJoyspace = "shareJoyspace",
  other = "other"
}
